<template>
  <div class="MapDialogue" @click="toggleMap();">
    
    <!-- Specific Content -->
    <div v-if="mapURL" class="md-container-specific" @click="$event.stopPropagation()">
      <img class="md-map" :src="publicPath+'/media'+mediaURL+mapURL" alt="">
      <SituationPin class="md-sp" v-for="(s, i) in sortedSituations" :key="s.id" :situation="s" :style="{'left': mapPins[i] ? mapPins[i].left : '', 'top':  mapPins[i] ? mapPins[i].top : ''}"/>
    </div>

    <!-- Generic Content --> 
    <div v-else class="md-container-generic">
      <SituationCard class="md-card" v-for="s in sortedSituations" :key="s.id" :situation="s"/>  
    </div>

  </div>
</template>
  
<style scoped>
  .MapDialogue{
    width: 100%;
    height: 100%; 
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1;
    background: #000000d0;
  }

  /* Generic Content */
  .md-container-generic {
    width: 80%;
    height: 80%;
    text-align: center;
    overflow-y: auto;
    background: rgba(48, 47, 47, 0.78);
    border-radius: 10px;
  }

  /* Specific Content */
  .md-container-specific {
    height: 80%;
    margin-top: 50px;
    position: relative;
    object-fit: contain;
  }
  .md-map{
    height: 100%;
  }
  .md-sp{
    position: absolute;
  }
  .md-card{
    margin: 20px;
    width: 330px;
    height: 200px;
  }
 
  /* Scrollbar CSS */
  ::-webkit-scrollbar{
    height: 13px;
  }
  ::-webkit-scrollbar-track{
    background: rgb(49, 49, 49);
    border-radius: 10px;
  }
  ::-webkit-scrollbar-thumb{
    border-radius:10px;
    border: 1px solid rgb(27, 27, 27);
    background: rgb(111,111,111);
  }

  /* Map size Mobile */
  @media (max-device-width: 900px){
    .md-container-specific {width: 90%;}
    @media (orientation:landscape){
      .md-container-specific {width: 50%;}
    }
  }
</style>

<script>
import {mapGetters} from 'vuex';
import SituationPin from '@/components/flux360/EmbeddedDialogues/MapDialogue/SituationPin'
import SituationCard from '@/components/flux360/EmbeddedDialogues/MapDialogue/SituationCard'

export default {
  components: {SituationPin, SituationCard},
  inject: ['toggleMap'],
  data: () => ({
    publicPath: process.env.BASE_URL,
  }),
	computed: {
    ...mapGetters(['mediaURL','situations','mapURL','mapPins',"roomOrder","panoramaTour"]),
    sortedSituations(){
      if(this.panoramaTour && this.roomOrder){
        let sortedSituations = [];
        this.roomOrder.forEach(e1 => {
          this.situations.forEach(e2 => {
              if(e1 == e2.getName().trim()){
                sortedSituations.push(e2);
                return;
              }
          });
        });
        return sortedSituations;
      }

      return this.situations;
    } 
	}
}
</script>

